import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getRefreshUrl } from '../helpers/getRefreshUrl';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
function EngagementHistoryError({
  isPermissionError
}) {
  const renderErrorMessage = () => {
    if (isPermissionError) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "components.engagementHistory.permissionError"
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "components.engagementHistory.error_jsx",
      options: {
        href: getRefreshUrl()
      },
      elements: {
        Link
      }
    });
  };
  return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "403",
    illustration: "errors/general",
    illustrationProps: {
      width: 150
    },
    children: /*#__PURE__*/_jsx(Text, {
      paddingInline: "500",
      as: "p",
      children: renderErrorMessage()
    })
  });
}
EngagementHistoryError.propTypes = {
  isPermissionError: PropTypes.bool
};
export default EngagementHistoryError;